// styles and images
import { useState } from "react";

// css and assets
import Close from "../../assets/close.svg";

// hooks
import { useEscape } from "../../hooks/useEscape";

// components
import FormButton from "../../formComponents/FormButton";
import InlineInput from "../../formComponents/InlineInput";
import { messageAndErrorStore } from "../../store/Store";

export default function PasswordReset({ setTrigger }) {
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)
  
  // state
  const [pending, setPending] = useState(false);
  const [email, setEmail] = useState("");

  const handleClose = () => {
    setTrigger(false);
    setEmail("");
  };

  useEscape(setTrigger, [setEmail], [""], pending);

  const handleReset = () => {
    // send email
    setPending(true);
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    const requestOptions = {
      headers,
      method: "POST",
      body: JSON.stringify(email),
      signal: controller.signal,
    };
    console.log("here");
    fetch(`${process.env.REACT_APP_BACKEND}/password-reset`, requestOptions)
      .then((res) => {
        if (res.ok) {
          toggleNewMessage(null, "Check your email");
          setPending(false);
          setTrigger(false);
        } else {
          toggleNewMessage("Something went wrong");
          setPending(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setPending(false);
      })
      .finally(() => setPending(false));
    return () => controller.abort();
  };

  return (
    <div className="popup">
      <div className="popup-inner">
        <div className="d-flex justify-content-between project-header">
          <h3>Reset Password</h3>
          {!pending && (
            <div className="close">
              <img
                onClick={handleClose}
                src={Close}
                alt="close"
                className="close"
              />
            </div>
          )}
        </div>
        <InlineInput
          name={"email"}
          title={"Email"}
          placeholder={"example@propx.com"}
          type={"text"}
          value={email}
          inputClass={"col"}
          onChange={(e) => setEmail(e.target.value)}
        />
        <FormButton pending={pending} name={"Submit"} onClick={handleReset} />
      </div>
    </div>
  );
}
